module.exports = __webpack_public_path__ + "static/media/21ECLAC44.b2db207c.jpg";